<template>
    <div id="app">
        <div v-if="!hideHeader" class="fixed-top">
            <!--
            <div v-if="showBanner" class="alert alert-purple alert-nav text-center" role="alert">
                <router-link to="/covid-19">Sleep Jar<span class="trademark">®</span> is providing free help during the Covid-19 health crisis. Learn more <i class="fas fa-angle-double-right"></i></router-link>
            </div>
            -->
            <nav class="navbar navbar-expand-lg navbar-dark">
                <a class="navbar-brand" href="/"><img src="/images/logo-white-512.png" class="mr-2 h-2-25rem"/>Sleep Jar<span class="trademark">®</span></a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item">
                            <router-link to="/" class="nav-link" @click.native="collapseNav">Home</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/sounds" class="nav-link" @click.native="collapseNav">Sleep Sounds</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/stories" class="nav-link" @click.native="collapseNav">Stories</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/journeys" class="nav-link" @click.native="collapseNav">Journeys</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/meditations" class="nav-link" @click.native="collapseNav">Meditations</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/alexa/link" class="nav-link" @click.native="collapseNav">Link to Alexa</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/premium" class="nav-link" @click.native="collapseNav">Premium Membership</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/faq" class="nav-link" @click.native="collapseNav">FAQ</router-link>
                        </li>
                        <!--
                        <li class="nav-item">
                            <router-link to="/careers" class="nav-link" @click.native="collapseNav">Careers</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/contact" class="nav-link">Contact Us</router-link>
                        </li>
                        <li class="nav-item d-none d-lg-block">
                            <router-link to="/covid-19" class="btn btn-outline-light">Covid-19 Response</router-link>
                        </li>
                        -->
                    </ul>
                    <nav-app-links/>
                </div>
            </nav>
        </div>

        <router-view class="pt-10"/>

        <footer v-if="!hideFooter" class="main-footer py-5">

            <div class="page-content">
                <div class="container">
                    <div class="row align-items-top text-left">
                        <div class="col-md-12 col-lg-3">
                            <p><router-link class="m-2" to="/">Home</router-link></p>
                            <p><router-link class="m-2" to="/sounds">Sleep Sounds</router-link></p>
                            <p><router-link class="m-2" to="/stories">Stories</router-link></p>
                            <p><router-link class="m-2" to="/journeys">Journeys</router-link></p>
                            <p><router-link class="m-2" to="/meditations">Meditations</router-link></p>
                        </div>

                        <div class="col-md-12 col-lg-3">
                            <p><router-link class="m-2" to="/alexa/link">Works with Alexa</router-link></p>
                            <p><router-link class="m-2" to="/premium">Premium Membership</router-link></p>
                            <p><router-link class="m-2" to="/faq">FAQ</router-link>|<router-link class="m-2" to="/contact">Contact Us</router-link></p>
                            <p><router-link class="m-2" to="/press">Press</router-link></p>
                            <p><router-link class="m-2" to="/careers">Careers</router-link></p>
                        </div>

                        <div class="col-md-12 col-lg-3">
                            <p><router-link class="m-2" to="/privacy">Privacy</router-link>|<router-link class="m-2" to="/terms">Terms of Use</router-link></p>
                            <p><router-link class="m-2" to="/alexa">Sleep Jar for Alexa</router-link></p>
                            <p><router-link class="m-2" to="/android">Sleep Jar for Android</router-link></p>
                            <p><router-link class="m-2" to="/ios">Sleep Jar for iPhone</router-link></p>
                            <p><router-link class="m-2" to="/firetv">Sleep Jar for Fire TV</router-link></p>
                        </div>

                        <div class="col-md-12 col-lg-3">
                            <p>{{copyright}}</p>
                            <p>Sleep Jar may earn commissions from the use of affiliate links.</p>
                            <p class="social">
                                <a href="https://twitter.com/sleepjar" target="_blank"><i class="fab mr-2 fa-twitter"></i></a>
                                <a class="ml-2" href="https://www.facebook.com/sleepjar/" target="_blank"><i class="fab mr-2 fa-facebook"></i></a>
                                <a class="ml-2" href="https://www.linkedin.com/company/sleepjar" target="_blank"><i class="fab mr-2 fa-linkedin"></i></a>
                            </p>
                            <!--
                            <div class="d-none d-lg-block">
                                <a href="https://www.producthunt.com/posts/sleep-jar?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-sleep&#0045;jar" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=369218&theme=neutral" alt="Sleep&#0032;Jar - Sleep&#0032;sounds&#0044;&#0032;stories&#0044;&#0032;and&#0032;meditations&#0032;for&#0032;mental&#0032;wellness | Product Hunt" style="width: 200px; height: 44px;" width="200" height="44" /></a>
                            </div>
                            -->
                        </div>


                    </div>
                </div>
            </div>

        </footer>

    </div>

</template>

    <script>
        export default {
            name: 'App',
            computed: {
                "copyright": function(){
                    return "© " + new Date().getFullYear() + " Invoked Apps LLC dba Sleep Jar";
                },
                "showBanner": function(){
                    console.info('showBanner');
                    console.info(this.$route);
                    console.info(this.$route.meta.showBanner === false ? false : true);
                    return this.$route.meta.showBanner === false ? false : true;
                },
                "hideHeader": function(){
                    return this.$route.meta.hideHeader || false;
                },
                "hideFooter": function(){
                    return this.$route.meta.hideFooter || false;
                },
                "alexaFooterLink": function(){
                    if(this.$root.country == "US"){
                        return "https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.032710b4-ae33-4f97-a8cf-d352a647b749/tasks/PlaySound/versions/1?a2z_ref=footer";
                    }else{
                        return "https://amzn.to/3juXvno";
                    }
                }
            },
            methods: {
                collapseNav() {
                    const navbarToggler = document.querySelector('.navbar-toggler');
                    const navbar = document.getElementById('navbarSupportedContent');
                    if (navbar && navbar.classList.contains('show') && navbarToggler) {
                        navbarToggler.click(); // Simulate toggler button press
                    }
                },
            },
            metaInfo: {
                // if no subcomponents specify a metaInfo.title, this title will be used
                title: 'Sleep Jar | Sleep sounds, stories, journeys, and meditations for sleep, relaxation, and focus on Alexa, Android, iPhone, and Fire TV.',
                // all titles will be injected into this template
                titleTemplate: '%s | Sleep Jar | Sleep Sounds, Stories, Journeys, and Meditations'
            }
        }
    </script>
